/**
 * PlatformStatement.tsx — påstandsavsnitt etter hero (IBM «overview»)
 */

import type { LandingPlatform } from '@/types/landing';
import styles from './landing-sections.module.css';

export default function PlatformStatement({ platform }: { platform: LandingPlatform }) {
  return (
    <section id="plattform" className={styles.section} aria-labelledby="platform-heading">
      <div className={styles.container}>
        <p className={styles.eyebrow}>{platform.eyebrow}</p>
        <div className={styles.statement}>
          <h2 id="platform-heading" className={styles.h2}>
            {platform.heading}
          </h2>
          <p className={styles.lead}>{platform.body}</p>
        </div>
      </div>
    </section>
  );
}
